import React from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CRow,
  CCardFooter,
  CButton,
  CLabel,
  CSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { Link } from "react-router-dom";

import Loader from "components/Loader";
import { mapEventsToOptions } from "utils/eventsUtils";
import { useReservation } from "context/reservationContext";
import Header from "components/Header";
import Finish from "components/Finish";
import { typeTicket } from "forms/reservation";

import FormAssistant from "./components/FormAssistant";
import TableAssistants from "./components/TableAssistants";

import "./styles.css";

const Reservation = ({ onReserve, showFinish, reservation, category }) => {
  const {
    showTable,
    assistants,
    events,
    handleSelectEvent,
    event,
    handleGoIglekids,
    iglekids,
    showInfoAssistants,
    setShowInfoAssistants,
    handleGoIglekidsAfterModal,
    setTicket
  } = useReservation();
  const options = mapEventsToOptions(events);

  return (
    <CContainer>
      <CRow className="justify-content-center">
        <Header showFinish={showFinish} />
      </CRow>
      <CRow className="justify-content-center">
        <CCol xs="12" md="9" lg="7" xl="6">
          {showFinish ? (
            <Finish code={reservation.code || ""} ticket={reservation.ticket || ""} />
          ) : (
            <CCard>
              <CCardBody>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {category === "NORMAL" && (
                      <CButton
                        color="warning"
                        onClick={handleGoIglekids}
                        size="sm"
                        style={{ marginRight: 10, marginBottom: 5 }}
                      >
                        Ir a registro para{" "}
                        {!iglekids ? "Iglekids" : "auditorio principal"}
                      </CButton>
                    )}
                    <Link to="/cancelar">
                      <CButton
                        color="danger"
                        size="sm"
                        style={{ marginBottom: 5, marginRight: 10 }}
                      >
                        Ir a web de cancelación
                      </CButton>
                    </Link>
                    <Link to="/consultar">
                      <CButton
                        color="info"
                        size="sm"
                        style={{ marginBottom: 5 }}
                      >
                        Consulta tu QR
                      </CButton>
                    </Link>
                  </div>
                  <CLabel style={{ marginTop: 10 }}>
                    Seleccione el servicio preferido
                  </CLabel>
                </div>
                <CSelect
                  custom
                  name="event"
                  defaultValue={event ? event.id : ""}
                  onChange={(e) => {
                    handleSelectEvent(e.target.value);
                  }}
                  disabled={assistants && assistants.length}
                >
                  {options &&
                    options.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                </CSelect>
                <p />

                <CLabel>{`Asientos disponibles: ${
                  event ? event.availableCapacity : 0
                }`}</CLabel>
                <br />
                {event && event.type === "PRV" && (
                  <>
                    <CLabel style={{ marginTop: 10 }}>Ticket</CLabel>
                    <CSelect
                      custom
                      name="tikcet"
                      onChange={(e) => {
                        setTicket(e.target.value);
                      }}
                      disabled={assistants && assistants.length}
                    >
                      {typeTicket &&
                        typeTicket.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                    </CSelect>
                  </>
                )}
                {showTable ? <TableAssistants /> : <FormAssistant />}
              </CCardBody>
              {showTable && (
                <CCardFooter>
                  <CButton
                    onClick={onReserve}
                    disabled={assistants.length < 1}
                    size="sm"
                    color="success"
                  >
                    Finalizar reserva
                  </CButton>
                </CCardFooter>
              )}
            </CCard>
          )}
        </CCol>
      </CRow>
      <CModal
        show={showInfoAssistants}
        onClose={() => setShowInfoAssistants(false)}
        size="sm"
      >
        <CModalHeader closeButton>
          <CModalTitle>Registro incompleto</CModalTitle>
        </CModalHeader>
        <CModalBody>
          Actualmente te encuentras realizando el registro para{" "}
          {event && event.description}, ¿Seguro que quieres salir?
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={handleGoIglekidsAfterModal}>
            Aceptar
          </CButton>{" "}
          <CButton
            color="secondary"
            onClick={() => setShowInfoAssistants(false)}
          >
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    </CContainer>
  );
};

export default Loader((props) => props.loading)(Reservation);
